import React from 'react'
import ErrorPageType from 'common/src/vtj/ErrorPageType.enum'
import ErrorPage from 'todistukset-ui/src/vtj/components/error-page/ErrorPage.react'

export interface NotAuthenticatedErrorProps {
  lang: string
}

const NotAuthenticatedError = (
  props: NotAuthenticatedErrorProps
): React.JSX.Element => {
  return (
    <ErrorPage errors={[ErrorPageType.SESSION_NOT_FOUND]} lang={props.lang} />
  )
}

export default NotAuthenticatedError
